import {
  Component, OnInit, Input, Output, EventEmitter,
} from '@angular/core';

import { IrisButtonTypes } from '@sondermind/iris/button';

@Component({
  selector: 'sondermind-pagination-control',
  templateUrl: './pagination-control.component.html',
  styleUrls: ['./pagination-control.component.scss'],
  standalone: false
})
export class PaginationControlComponent implements OnInit {
  pageRange: any[];
  @Input() count: number;
  @Input() page: number;
  @Input() delta: number;
  @Input() disabled: boolean;
  @Output() pageChanged = new EventEmitter<number>();

  irisButtonTypes = IrisButtonTypes;

  get hasPrev() { return this.page !== 1 }
  get hasNext() { return this.page !== this.count }

  ngOnInit() {
    this.setPageRange(this.page, this.count);
  }

  isSelected(num) {
    return this.page === num;
  }

  /**
   * function to generate an array that is to be rendered for pagination controls with ellipses
   *
   * @param {number} currentPage
   * @param {number} lastPage
   */
  setPageRange(currentPage: number, lastPage: number) {
    const range = [];

    // generate a range array
    // starts with either from 2 or a number that is greater and is the difference between current page and delta
    const rangeFirst = Math.max(2, currentPage - this.delta);
    // ends with eith the last page no. or a number that is less and is the summation of current page and delta
    const rangeLast = Math.min(lastPage - 1, currentPage + this.delta);
    for (let i = rangeFirst; i <= rangeLast; i += 1) {
      range.push(i);
    }

    // the position of undefined will help us know where to render the ellipses
    // depending on delta and the current page we can generate 3 array configurations [undefined, ...range], [...range, undefined], [undefined, ...range, undefined]
    if ((currentPage - this.delta) > 2) {
      // add undefined to range at the beginning of the array i.e [undefined, ...range]
      range.unshift(undefined);
    }
    if ((currentPage + this.delta) < (lastPage - 1)) {
      // add undefined to range at the end of the array  i.e [...range, undefined]
      range.push(undefined);
    }

    // add '1' at the beginning of the range
    range.unshift(1);

    // add the last page number after checking if it's greater than 1 so we dont end up with [1, 1]
    if (lastPage !== 1) {
      range.push(lastPage);
    }
    this.pageRange = range;
  }

  selectPage(page) {
    this.pageChanged.emit(page);
    this.page = page;
    this.setPageRange(this.page, this.count);
  }
}
